(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    if (!window.__cartSummaryBreakdownInitialized) {
    window.__cartSummaryBreakdownInitialized = true;

    const toggleBreakdown = (total) => {
      const root = total.closest('.cart__summary-totals');
      if (!root) return;

      const isOpen = root.classList.toggle('is-breakdown-open');
      total.setAttribute('aria-expanded', String(isOpen));
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const total = event.target.closest('.cart__summary-item.cart__total');
      if (!total) return;

      toggleBreakdown(total);
    });

    document.addEventListener('keydown', (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const total = event.target.closest('.cart__summary-item.cart__total');
      if (!total || event.target !== total) return;

      event.preventDefault();
      toggleBreakdown(total);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["four_hand-steps"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {

    const slider = document.querySelector('.fhs-slider');
    const dotsWrap = document.querySelector('.fhs-slider-dots');

    if (!slider || !dotsWrap) return;

    const cards = slider.querySelectorAll('.fhs-card');

    if (!cards.length) return;

    dotsWrap.innerHTML = '';

    cards.forEach((card,index)=>{

      const dot = document.createElement('button');

      dot.className = 'fhs-dot';

      if(index === 0){
        dot.classList.add('active');
      }

      dot.addEventListener('click',()=>{

        card.scrollIntoView({
          behavior:'smooth',
          inline:'start'
        });

      });

      dotsWrap.appendChild(dot);

    });

    slider.addEventListener('scroll',()=>{

      const sliderCenter =
        slider.scrollLeft +
        slider.offsetWidth / 2;

      let activeIndex = 0;
      let closest = Infinity;

      cards.forEach((card,index)=>{

        const cardCenter =
          card.offsetLeft +
          card.offsetWidth / 2;

        const distance =
          Math.abs(sliderCenter - cardCenter);

        if(distance < closest){
          closest = distance;
          activeIndex = index;
        }

      });

      document
        .querySelectorAll('.fhs-dot')
        .forEach(dot=>dot.classList.remove('active'));

      document
        .querySelectorAll('.fhs-dot')
        [activeIndex]
        ?.classList.add('active');

    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glp-banner"] && !Shopify.designMode) return;
  try {
    (() => {
      const syncHeroRatings = () => {
        const ratingEl = document.querySelector('.yotpo-sr-bottom-line-score');
        if (!ratingEl) return false;

        const rating = Number.parseFloat(ratingEl.textContent.trim());
        if (!Number.isFinite(rating)) return false;

        const formattedRating = rating.toFixed(1);
        document.querySelectorAll('.glphero-review-text').forEach((reviewText) => {
          const currentText = reviewText.textContent || '';
          const updatedText = currentText.replace(/\d+\.\d+/, formattedRating);
          if (updatedText !== currentText) {
            reviewText.textContent = updatedText;
          }
        });

        return true;
      };

      // Avoid waiting for DOMContentLoaded if this script is evaluated later.
      if (syncHeroRatings()) return;

      // Observe only until the rating appears; stop observing once it is synced.
      if (!document.body || !('MutationObserver' in window)) return;

      const observer = new MutationObserver(() => {
        if (syncHeroRatings()) observer.disconnect();
      });

      observer.observe(document.body, { childList: true, subtree: true });

      // Prevent a permanent observer if the Yotpo rating is not rendered.
      window.setTimeout(() => observer.disconnect(), 10000);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (function initMobileChildMenuShowMore() {
    const collapsedClass = 'mobile-child-menu-item--show-more-hidden';
    let lastToggleAt = 0;

    function getEventElement(event) {
      const target = event.target;
      if (target instanceof Element) return target;
      return target && target.parentElement;
    }

    function handleShowMoreToggle(event) {
      const eventElement = getEventElement(event);
      const toggle = eventElement && eventElement.closest('[data-show-more-toggle]');
      if (!toggle) return;

      event.preventDefault();
      event.stopPropagation();

      const now = Date.now();
      if (now - lastToggleAt < 400) return;
      lastToggleAt = now;

      const childMenuList = toggle.closest('.mobile-child-menu-list');
      if (!childMenuList) return;

      const accordionDetails = toggle.closest('details');
      if (accordionDetails) accordionDetails.open = true;

      const extraItems = childMenuList.querySelectorAll('[data-show-more-item]');
      const expanded = toggle.getAttribute('aria-expanded') === 'true';

      extraItems.forEach((item) => {
        item.classList.toggle(collapsedClass, expanded);
      });
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    }

    function bindShowMoreToggle() {
      document.addEventListener('click', handleShowMoreToggle, true);
      document.addEventListener('touchend', handleShowMoreToggle, { capture: true, passive: false });
    }

    function bindMenuOverflow() {
      const menuDrawer = document.querySelector('[data-header-drawer]');
      if (!menuDrawer) return;

      function updateMenuOverflowClass() {
        const openSubmenu = menuDrawer.querySelector('.mobile-menu-item-wrapper > details[open]');

        if (openSubmenu) {
          menuDrawer.classList.add('menu-overflow');
        } else {
          menuDrawer.classList.remove('menu-overflow');
        }
      }

      const menuItemDetails = menuDrawer.querySelectorAll('.mobile-menu-item-wrapper > details');

      menuItemDetails.forEach((details) => {
        details.addEventListener('toggle', updateMenuOverflowClass);
      });

      updateMenuOverflowClass();
    }

    function init() {
      bindShowMoreToggle();
      bindMenuOverflow();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["list-filter"] && !Shopify.designMode) return;
  try {
    const removeDrawerSearchInputs = () => {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    const drawerSearchWrappers = document.querySelectorAll(
      '.facets-drawer__options-content .facets__search-wrapper'
    );

    for (const wrapper of drawerSearchWrappers) {
      wrapper.remove();
    }
  };

  removeDrawerSearchInputs();

  const drawerSearchCleanupQuery = window.matchMedia('(min-width: 750px)');
  if (typeof drawerSearchCleanupQuery.addEventListener === 'function') {
    drawerSearchCleanupQuery.addEventListener('change', removeDrawerSearchInputs);
  } else {
    drawerSearchCleanupQuery.addListener(removeDrawerSearchInputs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-list-1"] && !Shopify.designMode) return;
  try {
    function applyScrollableScroll(container,direction){const items=Array.from(container.querySelectorAll("[data-scroll-item]")),limit=parseInt(container.getAttribute("data-scroll-limit")||"6",10);let currentStartIndex=0;for(let i=0;i<items.length;i++)if("none"!==items[i].style.display){currentStartIndex=i;break}const newStartIndex="up"===direction?Math.max(0,currentStartIndex-1):Math.min(items.length-limit,currentStartIndex+1);items.forEach((item,index)=>{item.style.display=index>=newStartIndex&&index<newStartIndex+limit?"":"none"});const scrollUpBtn=container.querySelector("[data-scroll-up]"),scrollDownBtn=container.querySelector("[data-scroll-down]");scrollUpBtn&&(scrollUpBtn.disabled=0===newStartIndex),scrollDownBtn&&(scrollDownBtn.disabled=newStartIndex>=items.length-limit)}function initMegaMenuScrollableHandlers(){if(window.__megaMenuScrollableInitialized)return;window.__megaMenuScrollableInitialized=!0,document.addEventListener("click",event=>{if(!(event.target instanceof Element))return;const upBtn=event.target.closest("[data-scroll-up]"),downBtn=event.target.closest("[data-scroll-down]");if(!upBtn&&!downBtn)return;const container=upBtn?upBtn.closest("[data-scrollable-container]"):downBtn.closest("[data-scrollable-container]");container&&applyScrollableScroll(container,upBtn?"up":"down")});let lastScrollableWheelTime=0;document.addEventListener("wheel",event=>{if(!(event.target instanceof Element))return;const container=event.target.closest("[data-scrollable-container]");if(!container)return;if(event.preventDefault(),Math.abs(event.deltaY)<1)return;const now="undefined"!=typeof performance&&performance.now?performance.now():Date.now();now-lastScrollableWheelTime<400||(lastScrollableWheelTime=now,applyScrollableScroll(container,event.deltaY>0?"down":"up"))},{passive:!1})}window.__megaMenuReadMoreInitialized||(window.__megaMenuReadMoreInitialized=!0,document.addEventListener("click",event=>{if(!(event.target instanceof Element))return;const toggle=event.target.closest("[data-readmore-toggle]");if(!toggle)return;"A"===toggle.tagName&&event.preventDefault();const listId=toggle.getAttribute("aria-controls"),list=listId?document.getElementById(listId):toggle.closest("[data-readmore-list]");if(!list)return;const limitValue=list.getAttribute("data-readmore-limit"),limit=limitValue?parseInt(limitValue,10):10,nextExpanded=!("true"===list.getAttribute("data-readmore-expanded"));list.setAttribute("data-readmore-expanded",nextExpanded.toString()),toggle.setAttribute("data-readmore-expanded",nextExpanded.toString()),toggle.setAttribute("aria-expanded","false");const moreText=toggle.getAttribute("data-readmore-more")||"Show all",lessText=toggle.getAttribute("data-readmore-less")||"Show less",textSpan=toggle.querySelector(".mega-menu__read-more-text"),iconSpan=toggle.querySelector(".mega-menu__read-more-icon");textSpan&&(textSpan.textContent=nextExpanded?lessText:moreText),iconSpan&&(iconSpan.hidden=nextExpanded);let index=0;const items=list.querySelectorAll("[data-readmore-item]");for(const item of items)item instanceof HTMLElement&&(index>=limit&&(item.hidden=!nextExpanded),index+=1);toggle instanceof HTMLElement&&toggle.blur(),requestAnimationFrame(()=>{requestAnimationFrame(()=>{const headerMenu=toggle.closest("header-menu");headerMenu&&"function"==typeof headerMenu.updateSubmenuHeight&&headerMenu.updateSubmenuHeight()})})})),window.applyMegaMenuScrollableScroll=applyScrollableScroll,window.initMegaMenuScrollableHandlers=initMegaMenuScrollableHandlers,initMegaMenuScrollableHandlers(),document.addEventListener("perf-defer:hydrated",initMegaMenuScrollableHandlers);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-list"] && !Shopify.designMode) return;
  try {
    if (!window.__megaMenuReadMoreInitialized) {
    window.__megaMenuReadMoreInitialized = true;

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const toggle = event.target.closest('[data-readmore-toggle]');
      if (!toggle) return;
      if (toggle.tagName === 'A') {
        event.preventDefault();
      }

      const listId = toggle.getAttribute('aria-controls');
      const list = listId ? document.getElementById(listId) : toggle.closest('[data-readmore-list]');
      if (!list) return;

      const limitValue = list.getAttribute('data-readmore-limit');
      const limit = limitValue ? parseInt(limitValue, 10) : 10;
      const expanded = list.getAttribute('data-readmore-expanded') === 'true';
      const nextExpanded = !expanded;

      list.setAttribute('data-readmore-expanded', nextExpanded.toString());
      toggle.setAttribute('aria-expanded', nextExpanded.toString());

      const moreText = toggle.getAttribute('data-readmore-more') || 'Show all';
      const lessText = toggle.getAttribute('data-readmore-less') || 'Show less';
      toggle.textContent = nextExpanded ? lessText : moreText;

      let index = 0;
      const items = list.querySelectorAll('[data-readmore-item]');
      for (const item of items) {
        if (!(item instanceof HTMLElement)) continue;
        if (index >= limit) {
          item.hidden = !nextExpanded;
        }
        index += 1;
      }

      // Recalculate mega menu panel height after show more/less (layout updates in next frame)
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const headerMenu = toggle.closest('header-menu');
          if (headerMenu && typeof headerMenu.updateSubmenuHeight === 'function') {
            headerMenu.updateSubmenuHeight();
          }
        });
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-banner-image"] && !Shopify.designMode) return;
  try {
    (function() {
    // Handle custom 2-image slider functionality
    const bannerSliders = document.querySelectorAll('.mobile-banner-slider');
    
    bannerSliders.forEach(function(slider) {
      const slidesContainer = slider.querySelector('.mobile-banner-slides');
      const prevArrow = slider.querySelector('.mobile-banner-arrow-prev');
      const nextArrow = slider.querySelector('.mobile-banner-arrow-next');
      const dots = slider.querySelectorAll('.mobile-banner-dot');
      const slides = slider.querySelectorAll('.mobile-banner-slide');
      
      if (!slidesContainer || slides.length !== 2) return;
      
      let currentSlide = 0;
      
      // Function to update slider state
      function updateSlider() {
        // Update slide position using transform
        // Each slide is 50% width, so we move by 50% per slide
        const translateX = currentSlide * -50;
        slidesContainer.style.transform = 'translateX(' + translateX + '%)';
        slidesContainer.setAttribute('data-current-slide', currentSlide);
        
        // Update arrow visibility
        if (currentSlide === 0) {
          // First slide: show right arrow, hide left arrow
          if (prevArrow) {
            prevArrow.style.display = 'none';
          }
          if (nextArrow) {
            nextArrow.style.display = 'flex';
          }
        } else if (currentSlide === 1) {
          // Second slide: show left arrow, hide right arrow
          if (prevArrow) {
            prevArrow.style.display = 'flex';
          }
          if (nextArrow) {
            nextArrow.style.display = 'none';
          }
        }
        
        // Update dots
        dots.forEach(function(dot, index) {
          if (index === currentSlide) {
            dot.classList.add('mobile-banner-dot-active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('mobile-banner-dot-active');
            dot.setAttribute('aria-current', 'false');
          }
        });
      }
      
      // Next slide function
      function nextSlide() {
        if (currentSlide < slides.length - 1) {
          currentSlide++;
          updateSlider();
        }
      }
      
      // Previous slide function
      function prevSlide() {
        if (currentSlide > 0) {
          currentSlide--;
          updateSlider();
        }
      }
      
      // Arrow click handlers
      if (nextArrow) {
        nextArrow.addEventListener('click', function(e) {
          e.preventDefault();
          nextSlide();
        });
      }
      
      if (prevArrow) {
        prevArrow.addEventListener('click', function(e) {
          e.preventDefault();
          prevSlide();
        });
      }
      
      // Dot click handlers
      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          currentSlide = index;
          updateSlider();
        });
      });
      
      // Initialize
      updateSlider();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-facets-sticky-footer"] && !Shopify.designMode) return;
  try {
    // Add body class for sticky footer spacing and handle visibility
  (function() {
    const stickyFooter = document.querySelector('.mobile-facets-sticky-footer');
    if (!stickyFooter) return;

    // Add body class for spacing on mobile
    function updateBodyClass() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        document.body.classList.add('has-mobile-facets-footer');
      } else {
        document.body.classList.remove('has-mobile-facets-footer');
      }
    }

    updateBodyClass();

    // Listen for resize
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    mobileQuery.addEventListener('change', updateBodyClass);

    // Hide sticky footer when any drawer is open
    function updateStickyFooterVisibility() {
      const filtersDrawer = document.querySelector('#filters-drawer[open]');
      const sortDrawer = document.querySelector('#drawer-mobile-sort-drawer dialog[open]');

      if (filtersDrawer || sortDrawer) {
        stickyFooter.style.display = 'none';
      } else {
        stickyFooter.style.display = '';
      }
    }

    // Watch for native filters drawer open/close
    const filtersDrawer = document.querySelector('#filters-drawer');
    if (filtersDrawer) {
      const observer = new MutationObserver(updateStickyFooterVisibility);
      observer.observe(filtersDrawer, { attributes: true, attributeFilter: ['open'] });
    }

    // Watch for sort drawer open/close
    const sortDrawerDialog = document.querySelector('#drawer-mobile-sort-drawer dialog');
    if (sortDrawerDialog) {
      const observer = new MutationObserver(updateStickyFooterVisibility);
      observer.observe(sortDrawerDialog, { attributes: true, attributeFilter: ['open'] });
    }

    document.addEventListener('dialog:open', updateStickyFooterVisibility);
    document.addEventListener('dialog:close', updateStickyFooterVisibility);

    // Show sticky footer only while scrolling within the results list bounds
    function updateScrollVisibility() {
      if (!mobileQuery.matches) {
        stickyFooter.classList.remove('mobile-facets-sticky-footer--visible');
        return;
      }

      const resultsList = stickyFooter.closest('results-list');
      if (!resultsList) return;

      const rect = resultsList.getBoundingClientRect();
      const scrollY = window.scrollY;
      const listTop = rect.top + scrollY;

      // Show only after entering the list; hide once list bottom rises above mid-screen
      const isPastListTop = scrollY > listTop;
      const isListBottomBelowMid = rect.bottom > window.innerHeight * 0.5;

      stickyFooter.classList.toggle(
        'mobile-facets-sticky-footer--visible',
        isPastListTop && isListBottomBelowMid
      );
    }

    window.addEventListener('scroll', updateScrollVisibility, { passive: true });
    mobileQuery.addEventListener('change', updateScrollVisibility);

    // Initial checks after layout is ready
    updateStickyFooterVisibility();
    requestAnimationFrame(updateScrollVisibility);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-sort-drawer"] && !Shopify.designMode) return;
  try {
    // Handle sort option change and close drawer
  (function() {
    const sortInputs = document.querySelectorAll('.mobile-sort-drawer__input');
    
    sortInputs.forEach(input => {
      input.addEventListener('change', async (e) => {
        const sortValue = e.target.value;
        const selectedLabel = e.target.closest('.mobile-sort-drawer__option-label');
        
        // Remove selected class from all option labels
        const allLabels = document.querySelectorAll('.mobile-sort-drawer__option-label');
        allLabels.forEach(label => {
          label.classList.remove('selected');
        });
        
        // Add selected class to the clicked option label
        if (selectedLabel) {
          selectedLabel.classList.add('selected');
        }

        // Update sort buttons (sticky footer and calmi bar) to show the selected option
        const selectedName = e.target.closest('.mobile-sort-drawer__option')?.querySelector('.mobile-sort-drawer__label')?.textContent?.trim();
        const sortSelectedLabels = document.querySelectorAll('[data-sort-selected-label]');
        sortSelectedLabels.forEach((label) => {
          if (selectedName) {
            label.textContent = selectedName;
          }
        });

        const calmiSortButton = document.querySelector('.facets-calmi__sort');
        if (calmiSortButton && selectedName) {
          const sortPrefix = calmiSortButton.querySelector('.facets-calmi__sort-label')?.textContent?.trim() || '';
          calmiSortButton.setAttribute('aria-label', sortPrefix ? `${sortPrefix} ${selectedName}` : selectedName);
        }
        
        // Find the facets-form-component on the page
        const facetsFormComponent = document.querySelector('facets-form-component');
        
        if (facetsFormComponent) {
          // Update any existing radio buttons in the form to maintain consistency
          const facetsForm = facetsFormComponent.querySelector('form[ref="facetsForm"]') || 
                            facetsFormComponent.querySelector('form');
          
          if (facetsForm) {
            // Update existing radio buttons to match the selected value
            const existingRadios = facetsForm.querySelectorAll('input[name="sort_by"][type="radio"]');
            existingRadios.forEach(radio => {
              radio.checked = radio.value === sortValue;
            });
            
            // Remove any duplicate hidden sort_by inputs (prevent duplicates)
            const hiddenInputs = facetsForm.querySelectorAll('input[name="sort_by"][type="hidden"]');
            hiddenInputs.forEach(hiddenInput => {
              hiddenInput.remove();
            });
          }
          
          // Close the drawer after 500ms delay
          setTimeout(async () => {
            const drawerComponent = document.querySelector('#drawer-mobile-sort-drawer');
            if (drawerComponent && typeof drawerComponent.closeDialog === 'function') {
              await drawerComponent.closeDialog();
            }
            
            // Trigger the filter update after drawer is fully closed
            // The radio button with form attribute will be included automatically
            if (typeof facetsFormComponent.updateFilters === 'function') {
              facetsFormComponent.updateFilters();
            }
          }, 500);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const productInformation = document.querySelector('.product-information');
  const blocks = productInformation.querySelectorAll('.shopify-block');
  
  
  blocks.forEach(block => {
    handleBlankBlocks(block);

    const config = { childList: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        handleBlankBlocks(mutation.target);
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(block, config);

  });

  function handleBlankBlocks(block) {
    if (block.childElementCount == 0) {
      block.classList.add('hidden');
    }else{
      block.classList.remove('hidden');
    }
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["three-column-product-information-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const productInformation = document.querySelector('.product-information');
    const blocks = productInformation.querySelectorAll('.shopify-block');
    
    
    blocks.forEach(block => {
      handleBlankBlocks(block);
  
      const config = { childList: true };
  
      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          handleBlankBlocks(mutation.target);
        }
      };
  
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);
  
      // Start observing the target node for configured mutations
      observer.observe(block, config);
  
    });
  
    function handleBlankBlocks(block) {
      if (block.childElementCount == 0) {
        block.classList.add('hidden');
      }else{
        block.classList.remove('hidden');
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ugc_video_section"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {

    const slider = document.querySelector('.LP_ugc-video-slider');
    const cards = document.querySelectorAll('.ugc-video-card');
    const prev = document.querySelector('.ugc-prev');
    const next = document.querySelector('.ugc-next');
    const dotsWrap = document.querySelector('.ugc-dots');

    if (!slider || !cards.length) return;

    /* --------------------------
        CREATE DOTS
    ---------------------------*/

    dotsWrap.innerHTML = '';

    cards.forEach((card, index) => {

        const dot = document.createElement('button');

        dot.className = 'ugc-dot';

        if(index === 0){
            dot.classList.add('active');
        }

        dot.addEventListener('click',()=>{

            card.scrollIntoView({
                behavior:'smooth',
                inline:'center',
                block:'nearest'
            });

        });

        dotsWrap.appendChild(dot);

    });

    const dots = dotsWrap.querySelectorAll('.ugc-dot');

    /* --------------------------
        UPDATE ACTIVE DOT
    ---------------------------*/

    function updateDots(){

        let active = 0;

        let closest = Infinity;

        const center =
        slider.scrollLeft +
        slider.offsetWidth/2;

        cards.forEach((card,index)=>{

            const cardCenter =
            card.offsetLeft +
            card.offsetWidth/2;

            const distance =
            Math.abs(center-cardCenter);

            if(distance < closest){

                closest = distance;

                active = index;

            }

        });

        dots.forEach(dot=>dot.classList.remove('active'));

        dots[active]?.classList.add('active');

    }

    /* --------------------------
        PAUSE OTHER VIDEOS
    ---------------------------*/

    const videos =
    slider.querySelectorAll('video');

    videos.forEach(video=>{

        video.addEventListener('play',()=>{

            videos.forEach(v=>{

                if(v!==video){

                    v.pause();

                }

            });

        });

    });

    function pauseAll(){

        videos.forEach(video=>{

            video.pause();

        });

    }

    /* --------------------------
        ARROWS
    ---------------------------*/

    next?.addEventListener('click',()=>{

        slider.scrollBy({

            left:slider.clientWidth,

            behavior:'smooth'

        });

        pauseAll();

    });

    prev?.addEventListener('click',()=>{

        slider.scrollBy({

         left:-slider.clientWidth,

            behavior:'smooth'

        });

        pauseAll();

    });

    /* --------------------------
        SCROLL
    ---------------------------*/

    slider.addEventListener('scroll',()=>{

        updateDots();

    });

    /* --------------------------
        TOUCH
    ---------------------------*/

    let startX = 0;

    slider.addEventListener('touchstart',(e)=>{

        startX = e.touches[0].clientX;

    });

    slider.addEventListener('touchend',(e)=>{

        const endX = e.changedTouches[0].clientX;

        if(Math.abs(startX-endX)>60){

            updateDots();

        }

    });

    updateDots();

});
  } catch(e) { console.error(e); }
})();

})();
